import React from 'react';

import UserRequestCardExclusive from "./user_request_card_exclusive";
import UserRequestCardDisperse from "./user_request_card_disperse";
import UserRequestCardNotOpen from "./user_request_card_not_open";

const UserRequestCard = ({request}) => {
    return (
        <div style={{ marginBottom: '5px'}}>
            {request.admin_id == null && request.social_worker_id == null ? (<UserRequestCardNotOpen request={request}/>) : request.request_type === 'Exclusivo' || request.request_type === 'Ajuda'?
                (<UserRequestCardExclusive request={request}/>) :
                (<UserRequestCardDisperse request={request}/>)}
        </div>);
}
export default UserRequestCard;
